var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViajar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_avi\\xF3n_lineal_color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.342,
    height: 63.337,
    viewBox: "0 0 63.342 63.337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104908",
    "data-name": "Trazado 104908",
    d: "M419.824,216.7a1.992,1.992,0,0,1,0-2.817l4.226-4.226a1.992,1.992,0,0,1,2.817,2.817l-4.226,4.226A1.992,1.992,0,0,1,419.824,216.7Zm0,0",
    transform: "translate(-367.374 -183.272)",
    fill: "#ee2b7c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104909",
    "data-name": "Trazado 104909",
    d: "M436.9,279.328a1.992,1.992,0,0,1,0-2.817l4.226-4.226a1.992,1.992,0,0,1,2.817,2.817l-4.226,4.226A1.992,1.992,0,0,1,436.9,279.328Zm0,0",
    transform: "translate(-382.34 -238.15)",
    fill: "#ee2b7c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104910",
    "data-name": "Trazado 104910",
    d: "M344.136,128.395,354,161.5l-2.377,2.377-18.752-25.62Zm0,0",
    transform: "translate(-291.687 -112.572)",
    fill: "#b1e0de"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104911",
    "data-name": "Trazado 104911",
    d: "M159.843,336.812l-3.521-9.156-5.634,5.634,6.338,6.339Zm0,0",
    transform: "translate(-132.045 -287.182)",
    fill: "#b1e0de"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104912",
    "data-name": "Trazado 104912",
    d: "M237.643,34.523a1.992,1.992,0,0,0,2.817,0l4.226-4.226a1.992,1.992,0,1,0-2.817-2.817l-4.226,4.226A1.993,1.993,0,0,0,237.643,34.523Zm0,0",
    transform: "translate(-207.732 -23.631)",
    fill: "#ee2b7c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104913",
    "data-name": "Trazado 104913",
    d: "M175.019,17.445a1.992,1.992,0,0,0,2.817,0l4.226-4.226a1.992,1.992,0,0,0-2.817-2.817l-4.226,4.226A1.992,1.992,0,0,0,175.019,17.445Zm0,0",
    transform: "translate(-152.855 -8.665)",
    fill: "#ee2b7c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104914",
    "data-name": "Trazado 104914",
    d: "M132.793,18.7,99.69,8.84l-2.377,2.377,25.619,18.752Zm0,0",
    transform: "translate(-85.273 -7.808)",
    fill: "#b1e0de"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104915",
    "data-name": "Trazado 104915",
    d: "M90.879,287.8l9.156,3.521L94.4,296.96l-6.339-6.339Zm0,0",
    transform: "translate(-77.168 -252.261)",
    fill: "#b1e0de"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104916",
    "data-name": "Trazado 104916",
    d: "M178.682,8.825C176.129,6.272,170.23,10.233,166,14.46c-12.678,12.678-32.4,36.625-32.4,36.625l2.817,2.817S160.37,34.18,173.047,21.5C177.273,17.277,181.235,11.378,178.682,8.825Zm0,0",
    transform: "translate(-117.077 -7.089)",
    fill: "#1aa8a2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104918",
    "data-name": "Trazado 104918",
    d: "M131.007,39.924l1.812-1.812a2.927,2.927,0,0,0-3.693-4.5l-.382-1.282,1.962-1.962a2.925,2.925,0,0,0-3.853-4.385l-2.324-7.8c.928-.894,1.818-1.764,2.656-2.6a30.922,30.922,0,0,0,5.529-7.2c1.944-3.764,1.13-5.775.105-6.8s-3.036-1.838-6.8.106a30.894,30.894,0,0,0-7.2,5.529c-.838.838-1.708,1.727-2.6,2.655l-7.8-2.324a2.924,2.924,0,0,0-4.385-3.853L102.068,5.65l-1.282-.382a2.926,2.926,0,0,0-4.5-3.693L94.47,3.387,85.236.636a.934.934,0,0,0-.927.235L81.932,3.248a.942.942,0,0,0,.109,1.414l23.3,17.055C100.087,27.64,95.026,33.57,91.453,37.807L84.6,35.171a.934.934,0,0,0-1,.211L80.787,38.2a.934.934,0,0,0,0,1.32L94.873,53.606a.943.943,0,0,0,1.321,0l2.817-2.817a.934.934,0,0,0,.211-1l-2.636-6.853c4.237-3.573,10.167-8.633,16.091-13.887l1.851,2.529a.934.934,0,0,0,1.507-1.1l-1.957-2.673c3.1-2.765,6.157-5.554,8.932-8.183l8.8,29.534L130.6,50.371,118.5,33.851a.934.934,0,1,0-1.507,1.1l12.735,17.4a.942.942,0,0,0,1.414.109l2.377-2.377a.934.934,0,0,0,.235-.927ZM105.35,5.009a1.058,1.058,0,1,1,1.5,1.5l-.438.438L104.1,6.256ZM97.6,2.9a1.058,1.058,0,0,1,1.5,1.5l-.288.288-2.306-.687Zm-13.58.9,1.213-1.213,29.534,8.8c-2.628,2.776-5.418,5.835-8.183,8.933ZM84.5,37.132l5.686,2.187c-1.426,1.7-2.52,3.012-3.165,3.79L82.768,38.86Zm3.847,7.3C91.6,40.508,108.8,19.866,120.141,8.53a29.437,29.437,0,0,1,6.734-5.19c1.524-.788,3.564-1.5,4.623-.445s.343,3.1-.445,4.623a29.451,29.451,0,0,1-5.19,6.734c-11.335,11.335-31.977,28.542-35.9,31.8ZM97.262,49.9l-1.728,1.728-4.249-4.249c.777-.645,2.092-1.738,3.79-3.164ZM130,35.294a1.058,1.058,0,0,1,1.5,1.5l-1.1,1.1-.687-2.306Zm-2.113-7.748a1.058,1.058,0,1,1,1.5,1.5l-1.248,1.248-.687-2.307Zm0,0",
    transform: "translate(-70.553 -0.499)",
    fill: "#3b0310"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104919",
    "data-name": "Trazado 104919",
    d: "M394.726,433.267l-7.968,7.968a.934.934,0,1,0,1.321,1.321l7.968-7.968a.934.934,0,0,0-1.321-1.321Zm0,0",
    transform: "translate(-338.673 -379.489)",
    fill: "#3b0310"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104920",
    "data-name": "Trazado 104920",
    d: "M385.007,402.382a.934.934,0,1,0-1.32-1.32l-4.98,4.98a.934.934,0,1,0,1.321,1.321Zm0,0",
    transform: "translate(-331.618 -351.267)",
    fill: "#3b0310"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104921",
    "data-name": "Trazado 104921",
    d: "M371.436,362.125a.934.934,0,1,0-1.321-1.321l-3.486,3.486a.934.934,0,0,0,1.321,1.321Zm0,0",
    transform: "translate(-321.035 -315.99)",
    fill: "#3b0310"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104922",
    "data-name": "Trazado 104922",
    d: "M9.562,50.83a.935.935,0,0,0-1.321,0L.273,58.8a.933.933,0,0,0,0,1.32.943.943,0,0,0,1.321,0l7.968-7.968A.935.935,0,0,0,9.562,50.83Zm0,0",
    transform: "translate(0.001 -44.364)",
    fill: "#3b0310"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104923",
    "data-name": "Trazado 104923",
    d: "M62.955,83.034a.933.933,0,0,0-1.32,0l-4.98,4.98a.934.934,0,1,0,1.32,1.32l4.98-4.98A.934.934,0,0,0,62.955,83.034Zm0,0",
    transform: "translate(-49.408 -72.584)",
    fill: "#3b0310"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_104924",
    "data-name": "Trazado 104924",
    d: "M108.967,112a.943.943,0,0,0,1.321,0l3.486-3.486a.934.934,0,0,0-1.321-1.321l-3.486,3.486A.935.935,0,0,0,108.967,112Zm0,0",
    transform: "translate(-95.246 -93.751)",
    fill: "#3b0310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViajar);
export default __webpack_public_path__ + "static/media/viajar.6a0018ee8f9f81e5c8b41511ec526ae3.svg";
export { ForwardRef as ReactComponent };